<template>
  <the-header></the-header>
  <router-view></router-view>
  <the-footer></the-footer>
</template>


<script>
import Header from './components/TheHeader.vue';
import Footer from './components/TheFooter.vue';
import { useMeta } from 'vue-meta';

export default {
  setup() {
    useMeta({
      title: 'In Your Hands LLC',
      htmlAttrs: { lang: 'en'},
      description: 'In Your Hands is an advertising company specializing in 9x12” postcards, delivered to 35,000 local homes, helping businesses reach more customers and boost visibility.',
      keywords: 'advertising company, direct mail advertising, bulk postcard mailers, 9x12 postcard advertising, small business advertising, affordable advertising for small businesses,local business marketing, advertise to 35,000 homes,cost-effective direct mail advertising',
      author: 'In Your Hands LLC',
      viewport: 'width=device-width, initial-scale=1.0',
      robots: 'index, follow', 
      link: [
        { rel: 'canonical', href: 'https://inyourhands-llc.com/' },
        { rel: 'icon', type: 'image/png', href: '/logo.png' },
        { rel: 'apple-touch-icon', href: '/logo.png' }
      ],
      titleTemplate: '%s | In Your Hands LLC',

    })
  },
  name: 'App',
    components: {
    'theHeader': Header,
    'theFooter': Footer
  },
  data() {
    return {
      minw: 0,
    }
  },
  mounted() {
    this.updateViewport();
    window.addEventListener('resize', this.updateViewport);

    const script = document.createElement('script');
    script.src = 'https://cdn.userway.org/widget.js';
    script.setAttribute('data-account', process.env.VUE_APP_USERWAY_DATA_ACCOUNT);
    script.setAttribute('alt', 'Accessibility Menu');
    document.head.appendChild(script);
  },
  methods: {
    updateViewport() {
      this.minw = window.screen.width*.75 + 'px';
    }
  }
}
</script>

<style>
@import url('https://fonts.googleapis.com/css?family=Alata');

html, body, #app {
  padding:0px;
  margin:0px;  
  width: fit-content;
  -webkit-box-sizing: border-box; /* Safari/Chrome, other WebKit */
  -moz-box-sizing: border-box;    /* Firefox, other Gecko */
  box-sizing: border-box; 
}

#app {
  background-color: #93A6BE;
  min-height:100vh;
  margin: 0;
  padding: 0;
  min-width: v-bind(minw);
}

h1 {
  margin: 0;
  padding: 0;
}

</style>
